module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-500-latin9.c0aa69c.woff2";